// import React, { useEffect, useState } from "react";
// import { Col, Card, Button } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import { SERVER_PATH } from "./../../config/env";
// import apiClient from "../../utils/api";
// import "./styles.css"

// const ProductsOfTheMonth = () => {
//   const [POMData, setPOMData] = useState([]);

//   const fetchPOMData = async () => {
//     try {
//       const res = await apiClient.post(
//         `get/product_of_month.php`,
//         {}
//       );
//       console.log("API Response:", res.data);
//       setPOMData(Array.isArray(res.data) ? res.data : []);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setPOMData([]); // Ensure it's always an array
//     }
//   };

//   useEffect(() => {
//     fetchPOMData();
//   }, []);

//   return (
//     <>
//       {POMData.length > 0 ? (
//         POMData.map((d, i) => (
//           <Col key={i} xs={12} sm={6} md={4} className="p-2">
//             <Card className="h-100 shadow-lg">
//               <div className="position-relative">
//                 <Card.Img
//                   variant="top"
//                   src={d.img1}
//                   alt=""
//                   className="w-100"
//                   style={{
//                     height: "100%",
//                     maxHeight: "300px",
//                     objectFit: "cover",
//                     padding: "5px",
//                   }}
//                 />
//               </div>
//               <Card.Body className="d-flex flex-column">
//                 <Card.Title
//                   className="text-center product-title"
//                 >
//                   {d.product_name}
//                 </Card.Title>
//                 <Card.Text
//                   className="flex-grow-1 text-muted"
//                   style={{ maxHeight: "120px", overflowY: "scroll" }}
//                 >
//                   {d.description}
//                 </Card.Text>
//                 <Button
//                   as={Link}
//                   to={`/product/${d.product_id}`}
//                   className="btn btn-success mt-auto"
//                 >
//                   View Product
//                 </Button>
//               </Card.Body>
//             </Card>
//           </Col>
//         ))
//       ) : (
//         <p className="text-center w-100">No products available.</p>
//       )}
//     </>
//   );
// };

// export default ProductsOfTheMonth;

import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SERVER_PATH } from "./../../config/env";
import apiClient from "../../utils/api";
import "./styles.css";

const ProductsOfTheMonth = () => {
  const [POMData, setPOMData] = useState([]);

  const fetchPOMData = async () => {
    try {
      const res = await apiClient.post(`get/product_of_month.php`, {});
      setPOMData(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.error("Error fetching data:", error);
      setPOMData([]);
    }
  };

  useEffect(() => {
    fetchPOMData();
  }, []);

  return (
    <>
      {POMData.length > 0 ? (
        POMData.map((d, i) => (
          <Col key={i} xs={12} sm={6} md={4} className="p-2">
            <div className="product-card">
              {/* Sale Badge */}
              {d.is_sale && <span className="sale-badge">Sale</span>}

              {/* Product Image */}
              <Link to={`/product/${d.product_id}`} className="product-link">
                <img
                  src={d.img1}
                  alt={d.product_name}
                  className="product-image"
                />
              </Link>

              {/* Pre-Seasoned Ribbon */}
              <span className="pre-seasoned">PRE-SEASONED</span>

              {/* Product Details */}
              <div className="product-details">
                <div className="price-section">
                  <br />
                  <h4 className="product-title">{d.product_name}</h4>
                  <div style={{display:"flex"}}>
                    {d.offer_price && (
                      <span className="old-price">Rs. {d.offer_price}</span>
                    )}
                    <span className="new-price">From Rs. {d.price}</span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        ))
      ) : (
        <p className="text-center w-100">No products available.</p>
      )}
    </>
  );
};

export default ProductsOfTheMonth;
